/**
 * File: authenticationPages.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v2.0.1
 * Created: 2025-12-04
 * Last Updated: 2026-06-22
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Local project files
import { routes } from "../../constants/routes";

// Forgot Password Page
export const forgotPasswordPage = {
    meta: {
        id: "forgot-password-page",
    },
    formHeader: {
        header: "Forgot Password?",
        subheader: "Enter your email and we’ll send you a verification code",
    },
    textButton: {
        text: "Send Code",
        type: "primary",
    },
    authPrompt: {
        message: "Remember your password?",
        text: "Sign In",
        linkHref: routes.public.auth.signIn.abs,
    },
};

// Reset Password Page
export const resetPasswordPage = {
    meta: {
        id: "reset-password-page",
    },
    formHeader: {
        header: "Reset Password",
        subheader: "Choose a new password for your account",
    },
    textButton: {
        text: "Reset Password",
    },
    authPrompt: {
        message: "Remember your password?",
        text: "Sign In",
        linkHref: routes.public.auth.signIn.abs,
    },
};

// Sign-In Page
export const signInPage = {
    meta: {
        id: "sign-in-page",
    },
    formHeader: {
        header: "Welcome Back",
        subheader: "Sign in to continue",
    },
    textButton: {
        text: "Sign In",
        type: "primary",
    },
    authPrompt: {
        message: "Don't have an account?",
        text: "Create Account",
        linkHref: routes.public.auth.signUp.abs,
    },
};

// Sign-Up Page
export const signUpPage = {
    meta: {
        id: "sign-up-page",
    },
    formHeader: {
        header: "Create Account",
        subheader: "Get started by creating your account",
    },
    textButton: {
        text: "Create Account",
        type: "primary",
    },
    authPrompt: {
        message: "Already have an account?",
        text: "Sign In",
        linkHref: routes.public.auth.signIn.abs,
    },
};

// Verification Code Page
export const verificationCodePage = {
    meta: {
        id: "verification-code-page",
    },
    formHeader: {
        header: "Verification Code",
        subheader: "We sent a verification code to ",
    },
    textButton: {
        text: "Verify",
    },
    authPrompt: {
        message: "Didn’t receive a code?",
        text: "Resend Code",
    },
};
